<template>
  <transition name="slide">
    <div v-if="gameOver" class="game-over">
      <h1>You Win!</h1>
      <button v-on:click="startOver">Start Over</button>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters(["gameOver"]),
  methods: mapActions(["startOver"])
};
</script>

<style scoped>
.game-over {
  position: fixed;
  padding-top: 100px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #fff;
}
button {
  border: 1px solid #ddbc07;
  background: #ffd800;
  font-size: 14px;
  padding: 7px 20px;
  border-radius: 20px;
  cursor: pointer;
}

.slide-enter-active {
  animation: slide 0.5s;
}
.slide-leave-active {
  animation: slide 0.5s reverse;
}

@keyframes slide {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
